var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlimited(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tap3xki8ya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.975 33.062c-.095 0-.19-.004-.283-.014-1.046-.032-3.906-.278-5.881-1.936-1.925-1.377-4.44-4.394-5.936-6.3a2.802 2.802 0 0 1-.287-.311c-2.373-3.006-4.03-4.63-4.725-5.105a2.842 2.842 0 0 1-.297-.234c-.385-.346-1.654-.613-2.525-.62h.014l-.01-5.606h.012c.68 0 3.964.1 6.157 1.942 1.812 1.293 4.162 4.074 5.572 5.84.114.105.22.22.315.343 2.373 3.055 4.253 4.98 5.063 5.532.104.072.203.15.297.234.383.345 1.642.61 2.52.62.067 0 .133.002.198.005a4.511 4.511 0 0 0 3.079-1.41 4.433 4.433 0 0 0 1.209-3.139 4.436 4.436 0 0 0-1.349-3.083 4.515 4.515 0 0 0-3.138-1.273v-5.606c2.692 0 5.274 1.06 7.178 2.947a10.016 10.016 0 0 1 2.972 7.114c0 2.668-1.069 5.227-2.973 7.114a10.196 10.196 0 0 1-7.177 2.946h-.005z",
    fill: "#174CC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.03 33.063c-2.693 0-5.275-1.06-7.178-2.947a10.015 10.015 0 0 1-2.973-7.114c0-2.668 1.07-5.227 2.973-7.114a10.197 10.197 0 0 1 7.177-2.946v5.605a4.516 4.516 0 0 0-3.143 1.274 4.436 4.436 0 0 0-1.347 3.09 4.433 4.433 0 0 0 1.218 3.141 4.512 4.512 0 0 0 3.087 1.4c.068-.004.137-.005.207-.005.873-.009 2.132-.274 2.52-.62a2.94 2.94 0 0 1 .296-.234c.698-.475 2.356-2.098 4.726-5.104a2.86 2.86 0 0 1 .287-.313c1.496-1.905 4.01-4.922 5.936-6.299 2.193-1.841 5.477-1.94 6.157-1.94h.011l-.01 5.605h.014c-.874.007-2.139.274-2.524.62a2.818 2.818 0 0 1-.297.234c-.81.553-2.69 2.477-5.063 5.532-.095.123-.2.239-.315.345-1.41 1.765-3.763 4.545-5.572 5.84-1.996 1.676-4.898 1.91-5.914 1.937a3.39 3.39 0 0 1-.274.013z",
    fill: "#5388FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tap3xki8ya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.875 12.938)",
    d: "M0 0h40.25v20.125H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimited);
export default __webpack_public_path__ + "static/media/unlimited.d1d495df1ba4929e53b2c3de2fdf0477.svg";
export { ForwardRef as ReactComponent };